
import { defineComponent } from 'vue'
import { DefaultImage, EpbPill, EpbText } from '../../shared'

export default defineComponent({
  name: 'ProductDetails',
  components: {
    DefaultImage,
    EpbText,
    EpbPill,
  },
  props: {
    imageUrl: {
      type: String,
      required: false,
      default: undefined,
    },
    name: {
      type: String,
      required: true,
    },
    productId: {
      type: String,
      required: true,
    },
    messages: {
      type: Object,
      required: true,
    },
    position: {
      type: Number,
      required: true,
    },
    isCompareModeEnabled: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    return {
      baseClass: 'epb-product-details',
    }
  },
})
